import { params, const_var } from "../reducer";
import * as cuBuilding from "../building_pricing/pricingReducer";
import * as cuComponent from "../building_component/componentReducer";

export const extrasState = {
	isSlidebarOpen: false,
	isOrderExtraNotesOpen: false,
	ExtraspriceCalculation: "",
	showhideleftpanel: false,
	order_extra_items: {},
	AddExtraNotes: "",
	LoginSession: false,
	isSlidebarOpencapture: false,
	ExtrascrmSetting: "",
	BlobImage: false,
	isShowCaptureModal: false,
	estimator_QuestionAnswer: "",
	BlobImageName: "",
	BlobImageIndex: 0,
	is_description: false,
	isAllCaptured: false,
	openAdditionalTab: false
};
extrasState.order_extra_items = const_var.order_extra_items;
extrasState.estimator_QuestionAnswer = const_var.estimator_QuestionAnswer;
extrasState.LoginSession = const_var.loginSession;
extrasState.ExtrascrmSetting = const_var.crmSetting;

window.onload = function () {
	if (window.innerWidth < 992) {
		const_var.ScrollCaptureEnd = false;
	} else {
		const_var.ScrollCaptureEnd = true;
	}
};

window.addEventListener("resize", () => {
	if (window.innerWidth < 992) {
		const_var.ScrollCaptureEnd = false;
	} else {
		const_var.ScrollCaptureEnd = true;
	}
});

const orderExtrasReducer = (state = extrasState, action) => {
	const newState = { ...state };
	switch (action.type) {
		case "onClickshowhideleftpanel":
			state.showhideleftpanel = !state.showhideleftpanel;
			return {
				...state,
				showhideleftpanel: state.showhideleftpanel
			};
			break;
		case "showImageEditor":
			const_var.isShowEmageEditor = action.flag;
			state.BlobImageName = action.value;
			if (action.key != "") {
				state.BlobImageIndex = action.key != "" ? action.key : state.BlobImageIndex;
				const_var.i_g_A_y[action.key].image = action.value;
			}

			return {
				...state,
				action
			};
			break;

		case "handleShowCapture":
			state.isSlidebarOpencapture = true;
			const bodydom = document.querySelector("body");
			bodydom.classList.add("isSlidebarOpen", "opencaptureview");

			setTimeout(function () {
				bodydom.classList.add("active-fullview");
				cuComponent.onResize();
			}, 400);

			return {
				...state,
				action
			};
			break;
		case "captureBlobImages":
			if (window.innerWidth < 993 && const_var.isMobileDraw == true) {
				const_var.renderer.setSize(1300, 900, false);
				const_var.renderer.setPixelRatio(window.devicePixelRatio);
				const_var.camera.aspect = 1300 / 900;
				const_var.camera.updateProjectionMatrix();
			}

			const_var.renderer.render(const_var.scene, const_var.camera);
			document.querySelector("body").classList.add("capture-animate");
			setTimeout(function () {
				document.querySelector("body").classList.remove("capture-animate");
			}, 1000);
			const_var.i_g_A_y.push({ image: const_var.renderer.domElement.toDataURL("image/jpeg", 1) });
			if (const_var.i_g_A_y.length > 0) {
				const_var.checkCaptuareImage = true;
			} else {
				const_var.checkCaptuareImage = false;
			}
			for (var i = 0; i < const_var.i_g_A_y.length; i++) {
				if (const_var.i_g_A_y[i].image_name == undefined || const_var.i_g_A_y[i].image_name == "") {
					if (action.event == "manual") {
						const_var.i_g_A_y[i].image_name = "Image " + (i + 1);
						const_var.isManualCapture = true;
					} else {
						let name = "";
						if (i == 0) {
							name = "Front";
						}
						if (i == 1) {
							name = "Right";
						}
						if (i == 2) {
							name = "Back";
						}
						if (i == 3) {
							name = "Left";
						}
						const_var.i_g_A_y[i].image_name = name;
					}
				}
			}

			if (window.innerWidth < 993 && const_var.isMobileDraw == true) {
				let classData = document.getElementsByClassName("buildingcanvas");
				const_var.camera.aspect = classData[0].clientWidth / classData[0].clientHeight;
				const_var.camera.updateProjectionMatrix();
				const_var.renderer.setSize(classData[0].clientWidth, classData[0].clientHeight);
				const_var.renderer.render(const_var.scene, const_var.camera);
			}

			state.BlobImage = !state.BlobImage;

			return {
				...state,
				action
			};
			break;

		case "isAllCaptured":
			state.isAllCaptured = action.value;
			return {
				...state,
				action
			};
			break;

		case "addSluginToBlobImages":
			if (action.label != "") {
				if (action.label == "image_name") {
					const_var.i_g_A_y[action.key].image_name = action.event.target.value;
				}
				if (action.label == "description") {
					const_var.i_g_A_y[action.key].description = action.event.target.value;
				}
				if (action.label == "is_description") {
					const_var.i_g_A_y[action.key].is_description = !action.event.target.value;
				}
				state.BlobImage = !state.BlobImage;
			} else {
				const_var.i_g_A_y.splice(action.key, 1);

				if (const_var.i_g_A_y.length > 0) {
					const_var.checkCaptuareImage = true;
				} else {
					const_var.checkCaptuareImage = false;
				}
				state.BlobImage = !state.BlobImage;
				document.querySelector("body").classList.add("capture-animate");
				setTimeout(function () {
					document.querySelector("body").classList.remove("capture-animate");
				}, 1000);
			}

			if (action.newKey == "CaptureMobile") {
				action.event.stopPropagation();
			}

			return {
				...state,
				action
			};
			break;
		case "handleShowExtras":
			if (action.key != "extra_close") {
				state.order_extra_items = const_var.order_extra_items;
				state.estimator_QuestionAnswer = const_var.estimator_QuestionAnswer;
			} else {
				state.isSlidebarOpen = false;
				const bodydom = document.querySelector("body");
				const slidepaneldom = document.querySelector(".slide-panel");
				bodydom.classList.remove("isSlidebarOpen", "active-fullview", "opencaptureview");
				setTimeout(function () {
					slidepaneldom.classList.add("device-capture-screen");
				}, 300);
				cuComponent.onResize();
			}
			return {
				...state,
				isSlidebarOpen: state.isSlidebarOpen + state.isOrderExtraNotesOpen
			};
			break;
		case "orderExtrasChangeValue":
			if (action.keyword == "yes") {
				action.event.target.value = action.event.target.value.replace(/[^0-9\.]/g, "");
				action.event.target.value = action.event.target.value.replace(/^0+/, "");
				action.event.target.value = action.event.target.value.replace(/,/g, "");
				state.order_extra_items[action.event.target.name] = action.event.target.value;
				var regex = /^\d+(\.\d{0,2})?$/g;
				if (!regex.test(state.order_extra_items[action.event.target.name])) {
					if (isNaN(parseFloat(state.order_extra_items[action.event.target.name])) == true || state.order_extra_items[action.event.target.name] == "") {
						state.order_extra_items[action.event.target.name] = 0;
					} else {
						state.order_extra_items[action.event.target.name] = state.order_extra_items[action.event.target.name].split(".");
						state.order_extra_items[action.event.target.name] = state.order_extra_items[action.event.target.name][0] + "." + state.order_extra_items[action.event.target.name][1].substring(0, 2);
					}
				}

				if (isNaN(state.order_extra_items[action.event.target.name])) {
					state.order_extra_items[action.event.target.name] = 0;
				}
				const_var.order_extra_items = state.order_extra_items;
				if (action.value == "processing_fee" && const_var.card_processing_fee != undefined) {
					const_var.card_processing_fee.is_edit = true;
				}
				if (action.value == "surchargeFees") {
					const_var.UpdatedPriceData.surcharge_amount = undefined;
					const_var.surcharge_amount_is_edit = true;
				}
				if (action.value == "surchargeFees" && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit = true;
				}

				cuBuilding.cP();
			} else {
				if (action.value == "additional_note") {
					state.order_extra_items["additional_note"] = action.event.target.value;
					const_var.order_extra_items = state.order_extra_items;
				} else if (action.value == "engineer_drawings") {
					let isInputContinue = action.event.target.value != "" && action.event.target.value.includes(".") && action.event.target.value.split(".")[1].length > 2 ? false : true;
					if (action.cost != undefined && action.drawingname != undefined) {
						const_var.engineer_drawings_price_changed = true;
					}
					if (isInputContinue) {
						if (action.drawingname != undefined) {
							state.order_extra_items["engineer_drawings_name"] = action.drawingname;
							state.order_extra_items["engineer_drawings"] = action.cost || 0;
							const_var.updated_engineer_drawings_price = action.cost || 0;
						} else {
							action.event.target.value = action.event.target.value.replace(/[^0-9\.]/g, "");
							action.event.target.value = action.event.target.value.replace(/^0+/, "");
							action.event.target.value = action.event.target.value.replace(/,/g, "");
							state.order_extra_items["engineer_drawings"] = action.event.target.value;
							const_var.updated_engineer_drawings_price = action.event.target.value;
						}
						state.order_extra_items = const_var.order_extra_items;
					}
					if (isNaN(parseFloat(state.order_extra_items["engineer_drawings"])) == true || state.order_extra_items["engineer_drawings"] == "") {
						state.order_extra_items["engineer_drawings"] = 0;
						state.order_extra_items = const_var.order_extra_items;
					}
				} else if (action.value == "description") {
					state.order_extra_items["description"] = action.event.target.value;
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "permit") {
					state.order_extra_items["permit"] = action.event.target.value;
					if (state.order_extra_items["permit"] === "yes") {
						if (const_var.loginSession != undefined && const_var.loginSession == false) {
							if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) {
							} else {
								let chkPermit = undefined;
								if (const_var.loginSession != true && const_var.stateManufacturerAcordingAPI[params.p_s_n].id != params.m_s_n) {
									if (const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision != undefined)
										chkPermit = const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.filter((data) => data.id == params.m_s_n)[0];
								}
								state.order_extra_items.order_permit_fee = chkPermit != undefined ? chkPermit.order_permit_fee : const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee;
							}
						} else {
							const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined &&
								const_var.stateManufacturerAcordingAPI[params.p_s_n].length > 0 &&
								const_var.stateManufacturerAcordingAPI[params.p_s_n].map((data) => {
									if (data.id == params.m_s_n) {
										if (params.m_s_n != 178) {
											//SE3-I6897
											const_var.is_edit_labour = undefined;
										}
										if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.crmSetting.is_module_name !== "inventory") {
											state.order_extra_items.order_permit_fee = 0;
										} else {
											state.order_extra_items.order_permit_fee = data.order_permit_fee;
										}
									}
								});
						}
					} else if (state.order_extra_items["permit"] === "no" || state.order_extra_items["permit"] === "cust_verify") {
						state.order_extra_items.order_permit_fee = 0;
						if (params.m_s_n != 178) {
							//SE3-I6897
							const_var.is_edit_labour = undefined;
						}
					}

					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "inside_city") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["inside_city"] = "yes";
					} else {
						state.order_extra_items["inside_city"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "surface_level") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["surface_level"] = "yes";
					} else {
						state.order_extra_items["surface_level"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "installation_ready") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["installation_ready"] = "yes";
					} else {
						state.order_extra_items["installation_ready"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "electricity") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["electricity"] = "yes";
					} else {
						state.order_extra_items["electricity"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "pdf_price_breakdown") {
					if (action.event.target.value == "" || action.event.target.value == "0") {
						state.order_extra_items["pdf_price_breakdown"] = "1";
					} else {
						state.order_extra_items["pdf_price_breakdown"] = "0";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "order_extra_additionalCharges") {
					const_var.additionalChargeArr.filter((data, ind) => {
						if (action.cost == ind && data.name != "") {
							var regex = /^\d+(\.\d{0,2})?$/g;
							if (!regex.test(action.event.target.value)) {
								data.price = 0;
							} else {
								data.price = action.event.target.value;
							}
						}
					});
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "welded_spacer") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["welded_spacer"] = "yes";
					} else {
						state.order_extra_items["welded_spacer"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "notched_lip") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["notched_lip"] = "yes";
					} else {
						state.order_extra_items["notched_lip"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "space_around_building") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["space_around_building"] = "yes";
					} else {
						state.order_extra_items["space_around_building"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else if (action.value == "site_clear_obstacle") {
					if (action.event.target.value == "" || action.event.target.value == "no") {
						state.order_extra_items["site_clear_obstacle"] = "yes";
					} else {
						state.order_extra_items["site_clear_obstacle"] = "no";
					}
					state.order_extra_items = const_var.order_extra_items;
				} else {
					state.order_extra_items[action.event.target.name] = action.event.target.value;
					const_var.order_extra_items = state.order_extra_items;
				}
				cuBuilding.cP();
			}
			return {
				...state,
				action
			};
			break;
		case "CheckCaptureModalImage":
			state.isShowCaptureModal = action.str;
			if (action.key == "empty") {
				const_var.i_g_A_y = [];
				const_var.checkCaptuareImage = false;
			}
			return {
				...state,
				action
			};
			break;
		case "addAdditionalCharge":
			if (action.key == "open") {
				state.openAdditionalTab = !state.openAdditionalTab;
			}
			if (action.key == "add") {
				const_var.additionalChargeArr.push({ name: "", "taxable & commissionable": false, price: 0 });
			}
			if (action.key == "name") {
				const_var.additionalChargeArr.map((data, ind) => {
					if (action.index == ind) {
						data.name = action.value;
					}
				});
			}
			if (action.key == "taxable") {
				const_var.additionalChargeArr.map((data, ind) => {
					if (action.index == ind) {
						data.taxable = action.value;
					}
				});
			}
			if (action.key == "delete") {
				const_var.additionalChargeArr = const_var.additionalChargeArr.filter((data, ind) => action.index != ind);
				cuBuilding.cP();
			}
			return {
				...state,
				action
			};
		case "UpdateState":
			state.order_extra_items = const_var.order_extra_items;
			return {
				...state,
				action: new Date()
			};
			break;
	}
	return newState;
};
export default orderExtrasReducer;
